export default "__VITE_ASSET__02$PMi65__"